import { mapState } from 'vuex'
// Constants
import { SHORTED_DAYS_LIST } from '@/constants'
// Components
import IconSvg from '@/components/IconSvg.vue'

export default {
	components: { IconSvg },

	computed: {
		...mapState('venue', [
			'toGoHours',
			'forHereHours',
			'isToGoOrderingAvailable',
			'isForHereOrderingAvailable',
			'pickUpHours',
			'currentDow',
			'isPickUpOrderingAvailable'
		]),

		...mapState({
			acceptToGo: state => state.venue.venueInfo.acceptToGo,
			acceptForHere: state => state.venue.venueInfo.acceptForHere,
			acceptPickUp: state => state.venue.venueInfo.acceptPickUp
		})
	},

	methods: {
		showSchedule(selected) {
			const { query, params } = this.$route

			let category = params.category

			if (this.$route.path.includes('/cart')) {
				query.isFromCart = 'true'
				category = query.category
			}

			this.$router.push({
				name: 'schedule',
				query: { ...query, category, selected: selected }
			})
		},

		getDayName(dayNumber) {
			return SHORTED_DAYS_LIST[dayNumber]
		}
	}
}
